import { z } from 'zod'
import { FirestoreTimestamp } from './utils'

/**
 * CustomerOrganization - Replaces "Building Owner Group" text fields
 * Provides hierarchical organization of building owners, property managers, etc.
 *
 * Collection path: customerOrganizations/{organizationId}
 */
export const CustomerOrganization = z.object({
  organizationId: z.string(),
  name: z.string(),
  type: z.enum(['building_owner', 'property_manager', 'facilities_dept']),

  // Sites belonging to this organization
  siteIds: z.array(z.string()).default([]),

  // Client users (building contacts) in this organization
  userIds: z.array(z.string()).default([]),

  // Which service company manages this organization
  serviceCompanyId: z.string(),

  // Status
  active: z.boolean().default(true),

  // Audit fields
  createdAt: FirestoreTimestamp,
  updatedAt: FirestoreTimestamp,
})

export type CustomerOrganization = z.infer<typeof CustomerOrganization>
